import {SelectProps} from '@mui/material/Select/Select'
import {InputContainer} from 'entities/inputs'
import {Select} from 'shared/ui/select'

type SelectWithLabelProps = SelectProps & {
  label: string
  name: string
}

export const SelectWithLabel: React.FC<SelectWithLabelProps> = ({
  children,
  label,
  name,
  required,
  ...rest
}) => {
  return (
    <InputContainer label={label} required={required} name={name}>
      <Select
        sx={{mt: '6px'}}
        isShowPlaceholderItem={false}
        displayEmpty
        name={name}
        {...rest}
      >
        {children}
      </Select>
    </InputContainer>
  )
}